import appConfig from '@/config/app.config'

/**
 * 项目默认配置项
 *
 */

export default Object.assign({
  appName: '极星云码', // 项目名称配置
  enableMenuPermit: true, // 开启菜单权限校验
  enablePageHeader: true, // 开启页面头部(面包屑)
  ServerAPI: 'https://api.8899.city',
  AMAP_KEY: '50bc57dd9f72732e4dcff303ab1b2bce' // 高德地图
}, appConfig)
